import { getEnv } from "./env";
const { NODE_ENV } = getEnv();
const ANALYTICS_LOG = Symbol("ANALYTICS_LOG");
if (NODE_ENV === "test" || NODE_ENV === "ut") {
  global[ANALYTICS_LOG] = global[ANALYTICS_LOG] || {
    baseProperties: {},
    identity: null,
    events: {},
  };
}
// This will be `undefined` unless running with NODE_ENV === "test"
const log = global[ANALYTICS_LOG];
const MockAnalyticsStore = {
  /**
   * Record a call to `setBaseProperties`
   *
   * **Internal use only**
   */
  _recordSetBaseProperties(properties) {
    if (NODE_ENV === "test") {
      log.baseProperties = properties;
    }
  },
  /**
   * Record a call to `identify`
   *
   * **Internal use only**
   */
  _recordIdentify(userId, traits) {
    if (NODE_ENV === "test") {
      log.identity = { userId, traits: traits || null };
    }
  },
  /**
   * Record a call to `track`
   *
   * **Internal use only**
   * @param event event name
   * @param properties event properties
   */
  _recordTrack(event, properties) {
    if (NODE_ENV === "test") {
      const events = log.events[event] || [];
      events.push({ ...log.baseProperties, ...properties });
      log.events[event] = events;
    }
  },
  /**
   * Returns the `userId` from the last call to `analytics.identify()
   */
  currentUserId() {
    if (NODE_ENV !== "test")
      throw new Error("You cannot use MockAnalyticsStore outside of tests");
    return log.identity && log.identity.userId;
  },
  /**
   * Returns the `traits` from the last call to `analytics.identify()`
   */
  currentUserTraits() {
    if (NODE_ENV !== "test")
      throw new Error("You cannot use MockAnalyticsStore outside of tests");
    return log.identity && log.identity.traits;
  },
  /**
   * Returns `true` if an event has been recorded
   */
  hasEvent(event) {
    if (NODE_ENV !== "test")
      throw new Error("You cannot use MockAnalyticsStore outside of tests");
    return !!log.events[event];
  },
  hasEventWithProperty(event, propertyKey, propertyValue) {
    if (NODE_ENV !== "test")
      throw new Error("You cannot use MockAnalyticsStore outside of tests");
    if (!MockAnalyticsStore.hasEvent(event)) return false;
    const events = log.events[event] || [];
    return !!events.find((p) => p[propertyKey] === propertyValue);
  },
  hasEventWithProperties(event, properties) {
    if (NODE_ENV !== "test")
      throw new Error("You cannot use MockAnalyticsStore outside of tests");
    if (!MockAnalyticsStore.hasEvent(event)) return false;
    const events = log.events[event] || [];
    return !!events.find((p) => {
      for (const key of Object.keys(properties)) {
        if (properties[key] !== p[key]) return false;
      }
      return true;
    });
  },
  reset() {
    log.baseProperties = {};
    log.identity = null;
    log.events = {};
  },
};
export default MockAnalyticsStore;
